import ServiceItem from "./ServiceItem";
import classes from "./ServiceList.module.css";

function ServiceList(props) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.pageHeader}>
        <h1>Services</h1>
      </div>

      <p className={classes.intro}>
        First Number Furniture offer a full service from initial design right through to
        completion. We fabricate, manufacture, construct and install something you are proud
        of and something that meets your exact specifications and requirements. We take pride
        in the conceptualisation of products &amp; materials used for the processes to
        successfully satisfy every need of our client.
      </p>

      <h2 className={classes.sectionTitle}>Our Services</h2>

      <div>
        {props.services.map((service) => (
          <ServiceItem
            key={service.id}
            id={service.id}
            image={service.image}
            title={service.title}
            description={service.description}
            description1={service.description1}
          />
        ))}
      </div>
    </div>
  );
}

export default ServiceList;
